export const apiUrl =
  process.env.REACT_APP_API_URL ||
  "https://event-platform-group-project.herokuapp.com";

export const DEFAULT_MESSAGE_TIMEOUT = 3000;
export const DEFAULT_PAGINATION_LIMIT = 10;
